import { render, staticRenderFns } from "./TheFavoritesIcon.vue?vue&type=template&id=76048c96&"
import script from "./TheFavoritesIcon.vue?vue&type=script&lang=js&"
export * from "./TheFavoritesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports